import { baseURL } from "../../constants";

const endPoint = "/users";
const path = `${baseURL}${endPoint}`;

export async function loginMobile(mobileNumber) {
  const url = `${path}/mobile`;
  const response = await fetch(url, {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify({ mobileNumber, platform: "web" }),
  });
  const json = await response.json();
  if (json && json['status']) {
    return json['status'];
  }
  return false;
}

export async function verifyOtp(mobileNumber, otp) {
  const url = `${path}/verifyOtp`;
  const response = await fetch(url, {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify({ mobileNumber, otp }),
  });
  const json = await response.json();
  if (json && json['status'] === "success") {
    console.log(json);
    window.localStorage.setItem("at", json.token);
    window.localStorage.setItem("rt", json.refreshToken);
    return true;
  }
  return false;
}
